import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

import type { Option } from "./gulaConstants";

export const SimpleSelect = ({
  label,
  value,
  onChange,
  options,
  placeholder = "Elegir…",
}: {
  label: string;
  value?: string | null;
  onChange: (value: string) => void;
  options: Option[];
  placeholder?: string;
}) => (
  <div className="flex flex-col gap-1.5">
    <Label>{label}</Label>
    <Select value={value ?? undefined} onValueChange={onChange}>
      <SelectTrigger className="w-full">
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        {options.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  </div>
);

export const Field = ({
  label,
  children,
}: {
  label: string;
  children: React.ReactNode;
}) => (
  <div className="flex flex-col gap-1.5">
    <Label>{label}</Label>
    {children}
  </div>
);
